import { Flex, Text, Divider } from '@shared/components';

interface QuestionSummarySectionProps {
  totalSingleQuestions?: number;
  totalItemSetQuestions?: string;
  selectedQuestions?: number;
  totalScore?: number;
}

export default function QuestionSummarySection(props: Readonly<QuestionSummarySectionProps>) {
  const { totalSingleQuestions, totalItemSetQuestions, selectedQuestions, totalScore } = props;

  return (
    <Flex
      sx={(theme) => ({
        backgroundColor: theme.palette.grey[50],
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[200]}`,
        p: theme.spacing(4),
        gap: theme.spacing(4),
        alignItems: 'center',
        minHeight: '62px',
      })}
    >
      <Flex sx={{ gap: (theme) => theme.spacing(2) }}>
        <Text variant='body2' sx={{ color: (theme) => theme.palette.text.secondary }}>
          Single:
        </Text>
        <Text variant='body2Semibold'>{totalSingleQuestions ?? '-'} ข้อ</Text>
      </Flex>
      <Divider orientation='vertical' flexItem />
      <Flex sx={{ gap: (theme) => theme.spacing(2) }}>
        <Text variant='body2' sx={{ color: (theme) => theme.palette.text.secondary }}>
          Item Set:
        </Text>
        <Text variant='body2Semibold'>{totalItemSetQuestions ?? '-'} ข้อ</Text>
      </Flex>
      <Divider orientation='vertical' flexItem />
      <Flex sx={{ gap: (theme) => theme.spacing(2) }}>
        <Text variant='body2' sx={{ color: (theme) => theme.palette.text.secondary }}>
          เลือกแล้ว{' '}
          <Text
            component='span'
            variant='body2Semibold'
            sx={{ color: (theme) => theme.palette.text.primary }}
          >
            {selectedQuestions ?? '0'}
          </Text>{' '}
          ข้อ
        </Text>
      </Flex>
      <Divider orientation='vertical' flexItem />
      <Flex sx={{ gap: (theme) => theme.spacing(2) }}>
        <Text variant='body2' sx={{ color: (theme) => theme.palette.text.secondary }}>
          คะแนนรวม{' '}
          <Text
            component='span'
            variant='body2Semibold'
            sx={{ color: (theme) => theme.palette.text.primary }}
          >
            {totalScore ?? '0'}
          </Text>{' '}
          คะแนน
        </Text>
      </Flex>
    </Flex>
  );
}
